import { removeModalScrollSafari } from 'helpers/removeModalScrollSafari'
import { ReactNode } from 'react'
import { Modal } from 'ui'

import style from './ModalWrap.module.scss'

type TModalWrap = {
  children: ReactNode
  isModalOpen: boolean
  tabletSmallSize?: boolean
  onClose: () => void
}

// обертка модального окна

export function ModalWrap({ children, isModalOpen, onClose }: TModalWrap) {
  const modalClose = () => {
    removeModalScrollSafari(false)
    onClose()
  }

  return (
    <Modal open={isModalOpen} onClose={modalClose}>
      <div className={style.modalWrap}>{children}</div>
    </Modal>
  )
}
